import { create } from 'zustand';
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import { persist } from 'zustand/middleware';

export const useMerchantUserStore = create()(
    persist(
        (set) => ({
            refetchMerchantUsers: false,
            storeRefetchMerchantUsers: (refetchMerchantUsers) => set(() => ({ refetchMerchantUsers: refetchMerchantUsers })),
            query: getInitialQuery(),
            storeQuery: (query) => set(() => ({ query: query }))
        }),
        {
            name: 'merchant-user-storage'
        }
    )
);

export default useMerchantUserStore;